import { render, staticRenderFns } from "./settingsDialog.vue?vue&type=template&id=c8847f04&scoped=true&"
import script from "./settingsDialog.vue?vue&type=script&lang=js&"
export * from "./settingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./settingsDialog.vue?vue&type=style&index=0&id=c8847f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8847f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8847f04')) {
      api.createRecord('c8847f04', component.options)
    } else {
      api.reload('c8847f04', component.options)
    }
    module.hot.accept("./settingsDialog.vue?vue&type=template&id=c8847f04&scoped=true&", function () {
      api.rerender('c8847f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom/components/settingsDialog.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom/components/settingsDialog.vue
// module id = Ga/z
// module chunks = 0